export default __webpack_public_path__ + "static/media/call.4d206d95.svg";